import Common from '../service/common'
import Vendor from '@/service/vendor'
// import Outstock from '../service/outstock'
import Supervise from '@/service/supervise'
import RequestUtils from './requestUtils.js'
import Permission from '../utils/permission'
import { guid } from '../utils/index'
const getFirstMenu = menu => {
  let url
  for (let i = 0; i < menu.length; i++) {
    const item = menu[i]
    if (item.funcAddress) {
      return item.funcAddress
    }
    if (item.children.length) {
      for (let j = 0; j < item.children.length; j++) {
        const sitem = item.children[j]
        if (sitem.funcAddress) {
          return sitem.funcAddress
        }
      }
    }
  }
  console.log(url)
  return url
}
export default {
  namespaced: true,
  state: {
    // staffType:企业帐号(100);二级监管机构操作员(200);二级监管机构管理员(202);一级监管机构管理员(208);运营端帐号(1000)
    userInfo: JSON.parse(localStorage.getItem('zs.userInfo')) || {},
    menu: JSON.parse(localStorage.getItem('zs.menu')) || [],
    permission: JSON.parse(localStorage.getItem('zs.permission')) || {},
    userDetail: JSON.parse(localStorage.getItem('zs.userDetail')) || {},
    warehouse: JSON.parse(localStorage.getItem('zs.warehouse')) || [],
    department: JSON.parse(localStorage.getItem('zs.department')) || [],
    module: JSON.parse(localStorage.getItem('zs.module')) || [],
    permmisions: JSON.parse(localStorage.getItem('zs.permmisions')) || {},
    expressList: JSON.parse(localStorage.getItem('zs.expressList')) || [],
    pageSizes: [10, 20, 50]
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = {
        ...state.userInfo,
        ...payload
      }
    },
    setPermission(state, payload) {
      state.permission = {
        ...state.permission,
        ...payload
      }
    },
    setExpressList(state, payload) {
      state.expressList = payload
    },
    setWarehouse(state, payload) {
      state.warehouse = payload
    },
    setDepartment(state, payload) {
      state.department = payload
    },
    setMenu(state, payload) {
      state.menu = payload
    },
    setModule(state, payload) {
      state.module = payload
    },
    setPermmisions(state, payload) {
      state.permmisions = payload
    },
    reset(state) {
      // localStorage.clear()
      localStorage.removeItem('zs.userInfo')
      localStorage.removeItem('zs.menu')
      localStorage.removeItem('zs.permission')
      localStorage.removeItem('zs.userDetail')
      localStorage.removeItem('zs.warehouse')
      localStorage.removeItem('zs.department')
      localStorage.removeItem('zs.module')
      localStorage.removeItem('zs.permmisions')
      localStorage.removeItem('zs.expressList')
      state.userInfo = {}
      state.permission = {}
      state.menu = []
    },
    setUserDetail(state, payload) {
      state.userDetail = payload
    }
  },
  actions: {
    getexpresses({ commit, dispatch, state }) {
      dispatch('vendor/getexpresses', {
        payload: {
          vendorId: state.userInfo.orgId,
          pageNum: 1,
          pageSize: 10000
        },
        success: (res) => {
          localStorage.setItem('zs.expressList', JSON.stringify(res.data.records))
          commit('setExpressList', res.data.records)
        },
        fail: () => {}
      }, { root: true })
    },
    login({ commit, dispatch }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.login(payload), {
        type: 'info',
        success: res => {
          const localData = {
            ...res.data,
            account: payload.account,
            vendorId: res.data.orgId
          }
          const permissionData = Permission.formatPermissionType(
            localData.userType,
            localData.isAdmin
          )
          localStorage.setItem('zs.userInfo', JSON.stringify(localData))
          localStorage.setItem('zs.permission', JSON.stringify(permissionData))
          commit('setUserInfo', localData)
          commit('setPermission', permissionData)
          dispatch('outstock/getwarehouses', {
            payload: {
              pageNum: 1,
              pageSize: 10000
            },
            success: (res) => {
              localStorage.setItem('zs.warehouse', JSON.stringify(res.data.records))
              commit('setWarehouse', res.data.records)
            },
            fail: () => {}
          }, { root: true })
          dispatch('vendor/getexpresses', {
            payload: {
              vendorId: localData.orgId,
              pageNum: 1,
              pageSize: 10000
            },
            success: (res) => {
              localStorage.setItem('zs.expressList', JSON.stringify(res.data.records))
              commit('setExpressList', res.data.records)
            },
            fail: () => {}
          }, { root: true })
          dispatch('vendor/getdepartments', {
            payload: {
              pageNum: 1,
              pageSize: 10000
            },
            success: (res) => {
              localStorage.setItem('zs.department', JSON.stringify(res.data.records))
              commit('setDepartment', res.data.records)
            },
            fail: () => {}
          }, { root: true })
          dispatch('wxaccount/updateUserDetail', {
            payload: {
              vendorId: localData.orgId
            },
            success: () => {},
            fail: () => {}
          }, { root: true })
          dispatch('getMenu', {
            payload: {},
            success,
            fail
          })
          if (res.data.orgType === 100) {
            dispatch('getvendorForStorage', {
              payload: {
                vendorId: res.data.orgId
              }
            })
          } else if ([200, 202, 208].indexOf(res.data.orgType) > -1) {
            dispatch('getregulatorForStorage', {
              payload: {
                vendorId: res.data.orgId
              }
            })
          }
        },
        fail: () => {
          fail && fail()
        }
      })
    },
    logout({ commit }, { success }) {
      RequestUtils.fetchWrapper(Common.logout(), {
        type: 'info',
        success: () => {
          commit('reset')
          success && success()
        },
        fail: () => {}
      })
    },
    getMenu({ commit }, { success, fail }) {
      RequestUtils.fetchWrapper(Common.getportalmenutree({}), {
        type: 'info',
        success: res => {
          // const menu = []
          const module = []
          const maps = {
            120: 'production',
            150: 'orders',
            140: 'warehouse',
            400: 'settings',
            430: 'weapp',
            600: 'stat'
          }
          res.data.menuNodes.forEach(s => {
            const firstMenu = getFirstMenu(s.children)
            module.push({
              ...s,
              activePath: maps[s.menuId],
              funcAddress: s.menuId === 400 ? '/settings' : firstMenu,
              children: formatMenu(s.children, s)
            })
          })
          console.log(module)
          localStorage.setItem('zs.permmisions', JSON.stringify({
            departmentPermissions: res.data.departmentPermissions,
            warehousePermissions: res.data.warehousePermissions
          }))
          localStorage.setItem('zs.module', JSON.stringify(module))
          commit('setModule', module)
          commit('setPermmisions', {
            departmentPermissions: res.data.departmentPermissions,
            warehousePermissions: res.data.warehousePermissions
          })
          function formatMenu(menus, parent) {
            const menuList = []
            if (parent.menuId === 400) {
              const menu = {
                funcAddress: '/settings',
                activePath: '/settings',
                children: null,
                operations: menus,
                menuName: parent.menuName
              }
              menuList.push(menu)
            } else {
              menus.forEach(i => {
                i.activePath = i.funcAddress || guid()
                const children = i.children || []
                children.forEach(s => {
                  s.activePath = s.funcAddress || guid()
                })
                menuList.push(i)
              })
            }

            return menuList
          }
          // localStorage.setItem('zs.menu', JSON.stringify(menu))
          // commit('setMenu', menu)
          // const url = getFirstMenu(module[0].funcAddress)
          success && success(module[0].funcAddress)
        },
        fail: () => {
          fail && fail()
        }
      })
    },
    getvendorForStorage({ commit }, { payload = {}}) {
      RequestUtils.fetchWrapper(Vendor.getvendor(payload), {
        type: 'info',
        success(res) {
          commit('setUserDetail', res.data)
          localStorage.setItem('zs.userDetail', JSON.stringify(res.data))
        },
        fail() {}
      })
    },
    getregulatorForStorage({ commit }, { payload }) {
      RequestUtils.fetchWrapper(Supervise.getregulator(payload), {
        type: 'info',
        success(res) {
          commit('setUserDetail', res.data)
          localStorage.setItem('zs.userDetail', JSON.stringify(res.data))
        },
        fail() {}
      })
    }
  }
}
